import { Box, Skeleton, Theme } from "@outschool/backpack";
import { Space } from "@outschool/ui-legacy-component-library";
import React from "react";

export default function ChooseAnotherTimeLoading() {
  return (
    <Box
      flex
      sx={(theme: Theme) => ({
        flexDirection: "column",
        [theme.breakpoints.up("md")]: {
          flexDirection: "row",
        },
        alignItems: "center",
        justifyContent: "center",
        paddingY: "1.25em",
        textAlign: "center",
        backgroundColor: "neutral.50",
      })}
    >
      <Skeleton variant="text" width={300} height={40} />
      <Space x="small" y="small" />
      <Box
        sx={{
          display: "grid",
          gridGap: "0.5em",
        }}
      >
        <Skeleton variant="rounded" width={240} height={46} />
      </Box>
    </Box>
  );
}
